import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "layout-column gap-md" };
const _hoisted_2 = { class: "typography-body-2-bold" };
const _hoisted_3 = { class: "layout-row gap-md justify-end" };
import { OrButtonV3 as OrButton, OrInputV3 as OrInput, OrModalV3 as OrModal, OrNotificationV3 as OrNotification, } from '@onereach/ui-components';
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import { ref, computed } from 'vue';
import passwordApi from '../../api/password';
import useI18n from '../../composables/useI18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PasswordRecoveryModal',
    props: {
        redirectPath: {}
    },
    setup(__props, { expose: __expose }) {
        const { translate } = useI18n();
        const props = __props;
        const resetError = ref('');
        const resetEmail = ref('');
        const prevEmail = ref('');
        const passwordLoading = ref(false);
        const forgotPasswordEmailSent = ref(false);
        const rules = computed(() => ({
            resetEmail: {
                required,
                email,
            },
        }));
        const v$ = useVuelidate(rules, { resetEmail });
        const passwordForgotStart = async () => {
            resetError.value = '';
            passwordLoading.value = true;
            if (v$.value.resetEmail.$invalid) {
                if (v$.value.resetEmail.required.$invalid) {
                    resetError.value = translate('login.password_restore.This field is required');
                }
                else if (v$.value.resetEmail.email.$invalid) {
                    resetError.value = translate('login.password_restore.Invalid value of email');
                }
                passwordLoading.value = false;
                return;
            }
            forgotPasswordEmailSent.value = false;
            const redirectPath = props.redirectPath;
            await passwordApi.startResetPassword(resetEmail.value, redirectPath)
                .then(() => {
                forgotPasswordEmailSent.value = true;
            })
                .catch(err => {
                var _a, _b, _c;
                const errorMessage = (_c = (_b = (_a = err.cause) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message;
                resetError.value = errorMessage || 'Something went wrong - please try later';
            });
            prevEmail.value = resetEmail.value;
            resetEmail.value = '';
            passwordLoading.value = false;
        };
        const resend = async () => {
            passwordLoading.value = true;
            const redirectPath = props.redirectPath;
            await passwordApi.startResetPassword(prevEmail.value, redirectPath)
                .catch(err => {
                var _a, _b, _c;
                const errorMessage = (_c = (_b = (_a = err.cause) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message;
                resetError.value = errorMessage || 'Something went wrong - please try later';
            });
            passwordLoading.value = false;
        };
        const onCloseResetPassword = () => {
            resetError.value = '';
            resetEmail.value = '';
            forgotPasswordEmailSent.value = false;
        };
        const root = ref(null);
        const open = () => {
            var _a;
            (_a = root.value) === null || _a === void 0 ? void 0 : _a.open();
        };
        __expose({
            open,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(OrModal), {
                ref_key: "root",
                ref: root,
                "remove-close-button": true,
                title: _ctx.$t('login.login.resetPassword'),
                size: "s",
                class: "reset-modal",
                "full-screen": false,
                onClose: onCloseResetPassword
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.login.resetPassword')), 1)
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (forgotPasswordEmailSent.value)
                            ? (_openBlock(), _createBlock(_unref(OrNotification), {
                                key: 0,
                                variant: "success",
                                "disable-close": ""
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", null, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('login.login.Instructions have been successfully sent to')) + " ", 1),
                                        _createElementVNode("span", _hoisted_2, _toDisplayString(prevEmail.value), 1),
                                        _createTextVNode(". ")
                                    ]),
                                    _createVNode(_unref(OrButton), {
                                        variant: "link",
                                        class: "!typography-body-2-bold",
                                        onClick: resend
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('login.login.resend')), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('login.login.enterYourEmail')), 1)
                        ]),
                        _createVNode(_unref(OrInput), {
                            modelValue: resetEmail.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((resetEmail).value = $event)),
                            modelModifiers: { trim: true },
                            error: resetError.value,
                            label: _ctx.$t('login.login.emailAddress'),
                            placeholder: _ctx.$t('session_expire.Enter email'),
                            class: "username",
                            name: "username",
                            type: "text",
                            onKeyup: _withKeys(passwordForgotStart, ["enter", "native"])
                        }, null, 8, ["modelValue", "error", "label", "placeholder"])
                    ])
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(OrButton), {
                            variant: "outlined",
                            class: "flex-1 md:!flex-none",
                            disabled: passwordLoading.value,
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => { var _a; return ((_a = root.value) === null || _a === void 0 ? void 0 : _a.close()); }, ["prevent"]))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('login.login.cancel')), 1)
                            ]),
                            _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_unref(OrButton), {
                            class: "flex-1 md:!flex-none",
                            color: "primary",
                            loading: passwordLoading.value,
                            onClick: _withModifiers(passwordForgotStart, ["prevent"])
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('login.login.submit')), 1)
                            ]),
                            _: 1
                        }, 8, ["loading"])
                    ])
                ]),
                _: 1
            }, 8, ["title"]));
        };
    }
});
